import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Typography, makeStyles, Box, Slider } from '@material-ui/core';
import maxBy from 'lodash/maxBy';
import minBy from 'lodash/minBy';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    marginBottom: theme.spacing(1),
  },
  summary: {
    background: theme.palette.background.default,
  },
  details: {
    border: '1px solid rgba(105, 109, 117, 0.15)',
    justifyContent: 'center'
  },
}));

const Salary = ({ school }) => {
  const classes = useStyles();

  const earningsData =
    school['latest.programs.cip_4_digit']?.length > 1
      ? [
          minBy(
            school['latest.programs.cip_4_digit'],
            'earnings.median_earnings',
          )?.earnings?.median_earnings,
          maxBy(
            school['latest.programs.cip_4_digit'],
            'earnings.median_earnings',
          )?.earnings?.median_earnings,
        ]
      : null;

  const marks = earningsData && [
    {
      value: earningsData[0],
      label: earningsData[0] ? `$${earningsData[0]?.toLocaleString()}` : 'N/A',
    },
    {
      value: earningsData[1],
      label: earningsData[1] ? `$${earningsData[1]?.toLocaleString()}` : 'N/A',
    },
  ];

  return (
    <div className={classes.root}>
      <Accordion elevation={0}>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          IconButtonProps={{
            edge: 'start',
            color: 'inherit',
          }}
          className={classes.summary}
        >
          <Typography variant="body2">
            Salary After Completing by Field of Study
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <Box
            padding={2}
            display="flex"
            flexDirection="column"
          >
            {earningsData ? (
              <Box display='flex' flexDirection='column'>
                <Typography>
                  Typical earnings in the first year after graduation with the
                  range of highest and lowest median earnings for undergraduate
                  and credential programs for which there is data. For more
                  information, see Fields of Study for this school.
                </Typography>
                <div style={{ paddingTop: 60, paddingBottom: 35 }}>
                  <Slider
                    value={earningsData}
                    marks={marks}
                    valueLabelDisplay="auto"
                    aria-labelledby="range-slider"
                    step={10000}
                    min={0}
                    max={(marks[1]?.value || 190000) + 10000}
                    disabled
                  />
                </div>
              </Box>
            ) : (
              <Typography align="center" variant="subtitle1">
                Data Not Available
              </Typography>
            )}
          </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default Salary;
